const postcodeValidation = () => {

    const postcode_input = document.querySelector('#postcode-validation');
    const postcode_button = document.querySelector('.postcode-validation-btn');
    const postcode_clear = document.querySelector('.postcode-validation-clear');
    const fail_result = document.querySelector('.fail-result');
    const success_result = document.querySelector('.success-result');
    const valid_postcodes = window.valid_postcodes.split(',');
    const product_section = document.querySelector('.product').closest('section');
    
    const clearPostcode = () => {
        postcode_input.value = '';
        fail_result.classList.remove('active');
        success_result.classList.remove('active');
    }

    const validatePostcode = (event) => {
        let input_postcode = postcode_input.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
        if(valid_postcodes.indexOf(input_postcode) >= 0) {
            success_result.classList.add('active');
            fail_result.classList.remove('active');
            product_section.classList.add('elegible');

            const y = product_section.getBoundingClientRect().top + window.pageYOffset - 100;
            window.scrollTo({
                top: y,
                behavior: "smooth"
            });

            localStorage.setItem(window.storage_key, 'true');
        } else {
            fail_result.classList.add('active');
            success_result.classList.remove('active');
            product_section.classList.remove('elegible');
            localStorage.setItem(window.storage_key, 'false');
        }
    }

    if(document.querySelector('.postcode-validation')) {
        if(localStorage.getItem(window.storage_key) == 'true') {
            success_result.classList.add('active');
            fail_result.classList.remove('active');
            product_section.classList.add('elegible');
        }
    }

    postcode_button.addEventListener('click', validatePostcode);
    postcode_clear.addEventListener('click', clearPostcode);
}

postcodeValidation();